<script setup>
import { ref, onMounted, onUnmounted, computed } from 'vue'
import { useRoute } from 'vue-router'
import Layout from '@/components/Layout/index.vue'
import { setHtmlRemUnit } from '@/util/common.js'
import { useLoading } from '@/util/loading'
import { VERSION } from '@/util/variable.js'

const isKeepAlive = ref(false)
const routerKey = ref('')
const route = useRoute()
const loading = useLoading()

const showLayout = computed(() => {
    return route.meta.layout === true
})

const handleResize = () => {
    setHtmlRemUnit()
}

onMounted(() => {
    routerKey.value = route.fullPath
    isKeepAlive.value = route.meta.keepAlive
    setHtmlRemUnit()
    window.addEventListener('resize', handleResize)
    
  console.log('版本号：', VERSION);
})

onUnmounted(() => {
    window.removeEventListener('resize', handleResize)
})
</script>

<template>
    <div class="app-container">
        <Layout v-if="showLayout">
            <keep-alive v-if="isKeepAlive">
                <router-view :key='routerKey'></router-view>
            </keep-alive>
            <router-view :key='routerKey' v-if="!isKeepAlive"></router-view>
        </Layout>
        <template v-else>
            <keep-alive v-if="isKeepAlive">
                <router-view :key='routerKey'></router-view>
            </keep-alive>
            <router-view :key='routerKey' v-if="!isKeepAlive"></router-view>
        </template>
        
        <div class="global-loading" :class="{'loading-show': loading.isLoading, 'loading-hide': !loading.isLoading}">
            <div class="loading-spinner">
                <svg viewBox="0 0 50 50" class="circular">
                    <circle cx="25" cy="25" r="20" fill="none" class="path"></circle>
                </svg>
            </div>
            <span class="loading-text">加载中...</span>
        </div>
    </div>
</template>

<style lang="scss">
.global-loading {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(255, 255, 255, 0.9);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    z-index: 9999;
    transition: opacity 0.3s;
    
    .loading-spinner {
        width: 42px;
        height: 42px;
        
        .circular {
            animation: loading-rotate 2s linear infinite;
            
            .path {
                stroke: #409eff;
                stroke-linecap: round;
                animation: loading-dash 1.5s ease-in-out infinite;
            }
        }
    }
    
    .loading-text {
        margin-top: 10px;
        color: #409eff;
        font-size: 14px;
    }
}

.loading-show {
    opacity: 1;
    visibility: visible;
}

.loading-hide {
    opacity: 0;
    visibility: hidden;
}

@keyframes loading-rotate {
    100% {
        transform: rotate(360deg);
    }
}

@keyframes loading-dash {
    0% {
        stroke-dasharray: 1, 200;
        stroke-dashoffset: 0;
    }
    50% {
        stroke-dasharray: 90, 150;
        stroke-dashoffset: -40px;
    }
    100% {
        stroke-dasharray: 90, 150;
        stroke-dashoffset: -120px;
    }
}
</style>